module.exports = __webpack_public_path__ + "img/products-and-services__background.14cfb11c.jpg";